import React from 'react';
import pt from 'prop-types';
import { Form, Field } from 'components/form';
import Modal from 'components/modal';
import './TransferStoreOwnership.scss';

class TransferStoreOwnership extends React.PureComponent {
  static propTypes = {
    partnerClient: pt.object.isRequired,
    width: pt.number,
    onSubmit: pt.func,
    onCancel: pt.func,
  };

  static contextTypes = {
    closeModal: pt.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  onSubmitForm = async ({ email }) => {
    const { onSubmit, partnerClient } = this.props;

    if (onSubmit) {
      this.setState({ loading: true });

      const result = await onSubmit(partnerClient.id, email);

      this.setState({ loading: false });

      if (!result) {
        return;
      }
    }

    this.context.closeModal();
  };

  onClickCancel = (event) => {
    event.preventDefault();

    this.props.onCancel?.();
    this.context.closeModal();
  };

  render() {
    const { width = 560 } = this.props;
    const { client } = this.props.partnerClient;
    const { loading } = this.state;
    const isPending = Boolean(client?.transfer_invite_code);

    return (
      <Form onSubmit={this.onSubmitForm}>
        <Modal
          title={isPending ? 'Resend transfer invite' : 'Transfer ownership'}
          width={width}
          className="transfer-store-ownership-modal"
          actions={[
            {
              label: isPending ? 'Resend invite' : 'Send invite',
              type: 'submit',
            },
            { label: 'Cancel', type: 'cancel', onClick: this.onClickCancel },
          ]}
          onClose={this.onClickCancel}
          cancel={false}
          closable={true}
          loading={loading}
        >
          <p className="transfer-store-ownership-modal-text">
            {isPending ? (
              <>
                A transfer invite is already pending for <b>{client?.name}</b> —
                the plan stays active on the partner sandbox in the meantime.
                Sending another one replaces it; only the most recent link will
                work.
              </>
            ) : (
              <>
                We&apos;ll email an invite to become the owner of{' '}
                <b>{client?.name}</b>. The store shows as Pending Transfer until
                they sign in and pick a plan — its current plan isn&apos;t
                canceled in the meantime.
              </>
            )}
          </p>
          <fieldset>
            <Field
              type="text"
              name="email"
              label="New owner's email"
              placeholder="owner@example.com"
              defaultValue={client?.transfer_invite_email}
              rules="required, email"
              required={true}
            />
          </fieldset>
        </Modal>
      </Form>
    );
  }
}

export default TransferStoreOwnership;
